import React from "react";

// Anchor component
const Anchor = (props) => {
  return (
    <a
      {...props}
      data-cursor={true} // This is for custom cursor
      target="_blank"
      className={`anchor-link ${props.className ? props.className : ""}`}
    >
      {props.children}
    </a>
  );
};

export default Anchor;

// Hr component
const Hr = ({ width = "100%" }) => {
  return (
    <div className="hr-container">
      <div className="hr-line" style={{ width }}></div>
    </div>
  );
};

// Button component
// const Button = (props) => {
//   return (
//     <button
//       data-cursor={true} // This is for custom cursor
//       {...props}
//       className={`font-light whitespace-nowrap flex justify-center items-center bg-v9-secondary-black px-3 py-1 border-2 rounded-md border-opacity-5 transition-colors ${
//         props.disabled
//           ? "opacity-50"
//           : "hover:border-v9-pink hover:border-opacity-30 "
//       } ${props.className ? props.className : ""}`}
//     />
//   );
// };

const Button = (props) => {
  return (
    <button
      data-cursor={true}
      {...props}
      className={`button-base ${
        props.disabled ? "button-disabled" : "button-hover"
      } ${props.className ? props.className : ""}`}
    >
      {props.children}
    </button>
  );
};

// Highlight Text
const HighlightText = (props) => {
  return <span className="highlight_text">{props.children}</span>;
};

export { Anchor, Hr, Button, HighlightText };
